import { Grid } from '@jutro/layout';
// eslint-disable-next-line import/order, import/no-unresolved
import appConfig from 'app-config';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ContactComponent from '../ContactComponent/ContactComponent';
import RssDirective from '../Directives/RssDirective/RssDirective';
import FacebookPageComponent from '../FacebookPageComponent/FacebookPageComponent';
import TextComponent from '../TextComponent/TextComponent';
import TwitterComponent from '../TwitterComponent/TwitterComponent';
import YoutubeComponent from '../YoutubeComponent/YoutubeComponent';
import './MediaSideBar.messages';
import mediaSidebarStyles from './MediaSideBar.module.scss';

function MediaSideBar(props) {

    /**
     * US26437: PE - Analytics
     * Allow multiple 'mediaSidebar' configurations since
     * Twia & TFPA have different requirements
     */
    const { showContact, uwCompany} = props;
    const sidebarConfig = uwCompany === 'tfpa' 
            ? (appConfig.mediaSidebarTFPA || appConfig.mediaSidebar)
            : appConfig.mediaSidebar;

    const { enabled, Facebook, Rss, Contact, Text, Twitter, Youtube } = sidebarConfig;

    if (uwCompany && enabled === true) {
        return (
            <Grid
                className={mediaSidebarStyles.gwMediaSidebarWrapper}
                gap="small"
            >
                {showContact && Contact.enabled && (
                    <ContactComponent
                        config={Contact.configuration}
                        key="contact"
                        id="contactSidebarWidget"
                    />
                )}
                {Text.enabled && (
                    <TextComponent
                        config={Text.configuration}
                        key="text"
                        id="textSidebarWidget"
                    />
                )}
                {Facebook.enabled && (
                    <FacebookPageComponent
                        config={Facebook.configuration}
                        key="facebook"
                        id="facebookSidebarWidget"
                    />
                )}
                {Rss.enabled && (
                    <RssDirective
                        limit={Rss.configuration.limit}
                        feed={Rss.configuration.feed}
                        key="rss"
                        id="rssSidebarWidget"
                    />
                )}
                {Twitter.enabled && (
                    <TwitterComponent
                        config={Twitter.configuration}
                        key="twitter"
                        id="twitterSidebarWidget"
                    />
                )}
                {Youtube.enabled && (
                    <YoutubeComponent
                        config={Youtube.configuration}
                        key="youtube"
                        id="youtubeSidebarWidget"
                    />
                )}
             
            </Grid>
        );
    }

    return null;
}

MediaSideBar.propTypes = {
    showContact: PropTypes.bool,
    uwCompany: PropTypes.string
};

MediaSideBar.defaultProps = {
    showContact: _.get(appConfig, 'mediaSidebar.Contact.enabled', false),
};

export default MediaSideBar;
